import React, { useState } from 'react'
import { getCostsChart } from 'src/services/api/charts'
import { Props } from './types'
import { Chart } from '../components/chart'
import { utilData } from '../components/util-data'

const chartData = {
  chart: {
    type: 'column'
  },
  title: {
    text: 'Divisão geral de custos',
    align: 'center'
  },
  subtitle: {
    text: '',
    align: 'left'
  },
  xAxis: {
    categories: [] as any
  },
  yAxis: {
    min: 0,
    title: {
      text: 'Percentual'
    }
  },
  tooltip: {
    pointFormat:
      '<span style="color:{series.color}">{series.name}</span>: <b>R$ {point.y:.2f}</b> ({point.percentage:.2f}%)<br/>',
    shared: true
  },
  plotOptions: {
    column: {
      stacking: 'percent',
      dataLabels: {
        enabled: true,
        format: '{point.percentage:.2f}%'
      }
    }
  },
  series: [] as any
}

function updateChatData(categories: [], series: []) {
  return {
    ...chartData,
    series,
    xAxis: {
      categories
    }
  }
}

export default function CostChart({ organization_id }: Props) {
  const [isLoading, setIsLoading] = useState(false)

  async function updateChart(monthFilter: string) {
    if (!monthFilter) {
      return chartData
    }

    setIsLoading(true)
    const date_end = utilData(monthFilter)
    const response = await getCostsChart(organization_id, monthFilter, date_end)

    setIsLoading(false)
    if (response.status !== 200) {
      return updateChatData([], [])
    }

    return updateChatData(
      response.data.data.categories,
      response.data.data.series
    )
  }

  return <Chart updateChart={updateChart} isLoading={isLoading} />
}
